import { FileText } from 'lucide-react';

import { definePanel } from '@/app/definePanel';
import { PanelMode, PanelTheme } from '@/types/panels';

export default definePanel({
    id: 'case_document',
    title: 'Document evidence',
    icon: FileText,
    width: { min: 384, default: 672, max: Infinity, fill: true },
    modes: [PanelMode.View],
    themes: PanelTheme.Any,
    isHeaderless: true,
    order: 100,
    hasNavButton: false,
});
